module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-96x96-90bf5deb7e1a3f092970561388b4a3e5.png";